import { useTranslation } from "react-i18next";
import { Button } from "@tellescope/ui";
import { DropdownMenu } from "@tellescope/design-system";
import { MoreHorizontal, Pencil, Trash2 } from "lucide-react";

interface EntryActionsMenuProps {
  onEdit: () => void;
  onDelete: () => void;
}

export const EntryActionsMenu = ({ onEdit, onDelete }: EntryActionsMenuProps) => {
  const { t } = useTranslation("portal");

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-7 w-7 p-0"
          onClick={(e) => e.stopPropagation()}
          aria-label={t("Entry actions")}
        >
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="end">
        <DropdownMenu.Item
          onClick={(e) => {
            e.stopPropagation();
            onEdit();
          }}
        >
          <Pencil className="h-3.5 w-3.5 mr-2" />
          {t("Edit")}
        </DropdownMenu.Item>
        <DropdownMenu.Item
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          className="text-destructive focus:text-destructive"
        >
          <Trash2 className="h-3.5 w-3.5 mr-2" />
          {t("Delete")}
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};
